export default __webpack_public_path__ + "static/media/estatetype.08d447a8.svg";